import { render, staticRenderFns } from "./mediaDetail.vue?vue&type=template&id=54f3b9a9&scoped=true&"
import script from "./mediaDetail.vue?vue&type=script&lang=js&"
export * from "./mediaDetail.vue?vue&type=script&lang=js&"
import style0 from "./mediaDetail.vue?vue&type=style&index=0&id=54f3b9a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3b9a9",
  null
  
)

export default component.exports